import axios from 'axios'
import router from './router/index'

//请求初始化配置
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
//环境配置

// axios.defaults.baseURL = "https://cloud.linked-go.com:449";  // 欧洲正式环境
   axios.defaults.baseURL = "https://cloud.go-heating.com:446";  // 欧洲正式环境
// axios.defaults.baseURL = "http://8.209.79.195";  // 欧洲测试环境


// sessionStorage.setItem('sessionid','B51C05D25E6A1F8656D82A0B5C06C315');
// 添加请求拦截器
axios.interceptors.request.use(function(config) {
	// 在发送请求之前做些什么
	let url = config.url
	config.url = config.url.indexOf('?') > -1 ? url.concat('&lang=en') : url.concat('?lang=en');
	// if (sessionStorage.getItem('sessionid')) {
	// 	let pattern = sessionStorage.getItem('pattern')
	// 	if (config.data) {
	// 		config.data.sessionid = sessionStorage.getItem('sessionid');
	// 		if (pattern == 'D') {
	// 			config.data.pattern = 'D'
	// 		}
	// 	}
	// }

	return config;
}, function(error) {
	// 对请求错误做些什么
	return Promise.reject(error);
});

axios.interceptors.response.use(function(response) {
	// 对响应数据做点什么

	// if(response.data.code == -100) {
	// 	router.replace({
	// 		path: "/",
	// 		redirect: '/login'
	// 	})
	// } else if(response.data.code == -1 && response.data.msg == '超时，请重新登录') {
	// 	router.replace({
	// 		path: "/",
	// 		redirect: '/login'
	// 	})
	// }
	return response

}, function(error) {
	// 对响应错误做点什么
	if(error.response) {
		switch(error.response.status) {
			// case 401:
			// 	router.replace({
			// 		path: "/",
			// 		redirect: '/login'
			// 	})
			// case 404:
			// 	router.replace({
			// 		path: "/",
			// 		redirect: '/home'
			// 	})
		}
	}
	return Promise.reject(error)
})


export default axios



// WEBPACK FOOTER //
// ./src/http.js